// extracted by mini-css-extract-plugin
module.exports = {"fileView":"FileView_fileView__9UdIR","fileSize":"FileView_fileSize__3CsUm","fileName":"FileView_fileName__-p28j"};